<template>
    <div class="lm-small-text">
        <p><slot></slot></p>
    </div>
</template>

<script>
    export default {
        name: "LoveMapSmallText"
    }
</script>

<style lang="scss" scoped>
    .lm-small-text{
        text-align: left;
        &.center{
            text-align: center;
        }
        &.left{
            text-align: left;
        }

        &.no-margin{
            p{
                margin-top: -5px;
                margin-bottom: 0;
            }
        }
        p {
            font-style: italic;
            vertical-align: baseline;
            display: inline-block;
            font-size: 10px;
            color: #444444;
        }
    }
</style>